export const SET_IS_ALL = 'SET_IS_ALL';
export const SET_SALAS = 'SET_SALAS';

